/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "pricingplan": {
        "nested": {
          "service": {
            "nested": {
              "PricingPlanClassification": {
                "values": {
                  "PRICING_PLAN_CLASSIFICATION_UNKNOWN": 0,
                  "PRICING_EXPERIMENT_V0": 1,
                  "PRICING_EXPERIMENT_V1": 2,
                  "PRICING_EXPERIMENT_TIERED_V1": 11,
                  "PRICING_EXPERIMENT_V2": 3,
                  "DUAL_MODE_V1": 4,
                  "AUTOMATED_PRICING_DISCOUNT_V2": 5,
                  "UNIT_TEST": 6,
                  "CBD_PRICING": 7,
                  "PRICING_EXPERIMENT_V2_NO_HARDWARE": 8,
                  "DUAL_MODE_V2": 9,
                  "DUAL_MODE_V3": 10,
                  "MODERN_MICROS_M0": 12
                }
              },
              "PricingPlanOffer": {
                "fields": {
                  "pricingPlanOfferId": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "offerType": {
                    "type": "squareup.pricingplan.service.PricingPlanOffer.OfferType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.pricingplan.service.PricingPlanOffer.OfferStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "rateDetails": {
                    "type": "squareup.pricingplan.service.OfferRateDetails",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "salesHistory": {
                    "type": "squareup.pricingplan.service.SalesHistory",
                    "id": 6,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "OfferType": {
                    "values": {
                      "UNKNOWN": 0,
                      "AUTOMATED_PRICING_DISCOUNT_V2_US": 1,
                      "AUTOMATED_PRICING_DISCOUNT_V2_GB": 2,
                      "AUTOMATED_PRICING_DISCOUNT_V2_AU": 3
                    }
                  },
                  "OfferStatus": {
                    "values": {
                      "INVALID": 0,
                      "PENDING": 1,
                      "ACCEPTED": 2,
                      "EXPIRED": 3,
                      "REVOKED": 4
                    }
                  }
                }
              },
              "SalesHistory": {
                "fields": {
                  "timePeriod": {
                    "type": "squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timePeriodDescription": {
                    "type": "squareup.pricingplan.service.SalesHistory.TimePeriodDescription",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pricingBundleSales": {
                    "type": "squareup.pricingplan.service.PricingBundleSales",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TimePeriodDescription": {
                    "values": {
                      "UNKNOWN": 0,
                      "LAST_SIX_MONTHS": 1,
                      "LAST_YEAR": 2,
                      "THIS_YEAR": 3,
                      "ALL_TIME": 4
                    }
                  }
                }
              },
              "Rate": {
                "fields": {
                  "basisPoints": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "interchangeCents": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OfferRateDetails": {
                "fields": {
                  "pricingBundleName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "oldRate": {
                    "type": "squareup.pricingplan.service.Rate",
                    "id": 2,
                    "rule": "optional"
                  },
                  "newRate": {
                    "type": "squareup.pricingplan.service.Rate",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PricingBundleSales": {
                "fields": {
                  "pricingBundleName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "defaultRate": {
                    "type": "squareup.pricingplan.service.Rate",
                    "id": 2,
                    "rule": "optional"
                  },
                  "appliedRate": {
                    "type": "squareup.pricingplan.service.Rate",
                    "id": 3,
                    "rule": "optional"
                  },
                  "totalSales": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalFees": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "transactionCount": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "TerminationConditions": {
                "fields": {
                  "feeAmount": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "minimumBilledMonths": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TerminationStatus": {
                "fields": {
                  "returnInitiated": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "monthsBilled": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "returnByDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FeePlanRate": {
                "fields": {
                  "defaultCpBasisPoints": {
                    "type": "uint32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "defaultCpInterchangeCents": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cpBasisPoints": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cpInterchangeCents": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FetchFlag": {
                "values": {
                  "NONE": 0,
                  "RETURN_STATUS": 1,
                  "BILLING_STATUS": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanClassification && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanOffer && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanOffer?.nested?.OfferType && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanOffer?.nested?.OfferStatus && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.SalesHistory && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.SalesHistory?.nested?.TimePeriodDescription && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.Rate && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.OfferRateDetails && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingBundleSales && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.TerminationConditions && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.TerminationStatus && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.FeePlanRate && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.FetchFlag) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PricingPlanClassification @ squareup/pricingplan/common.proto at 11:1
 */
export const PricingPlanClassification = $root.lookupEnum('squareup.pricingplan.service.PricingPlanClassification').values;
/**
 * SOURCE PricingPlanOffer @ squareup/pricingplan/common.proto at 27:1
 */
export const PricingPlanOffer = $root.lookupType('squareup.pricingplan.service.PricingPlanOffer');
fixType(PricingPlanOffer, {
  pricingPlanOfferId: {
    required: true
  },
  offerType: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(PricingPlanOffer);
/**
 * SOURCE OfferType @ squareup/pricingplan/common.proto at 28:3
 */
PricingPlanOffer.OfferType = $root.lookupEnum('squareup.pricingplan.service.PricingPlanOffer.OfferType').values;
/**
 * SOURCE OfferStatus @ squareup/pricingplan/common.proto at 35:3
 */
PricingPlanOffer.OfferStatus = $root.lookupEnum('squareup.pricingplan.service.PricingPlanOffer.OfferStatus').values;
/**
 * SOURCE SalesHistory @ squareup/pricingplan/common.proto at 55:1
 */
export const SalesHistory = $root.lookupType('squareup.pricingplan.service.SalesHistory');
fixType(SalesHistory, {
  timePeriod: {
    required: true
  },
  timePeriodDescription: {
    required: true
  },
  pricingBundleSales: {
    required: true
  }
});
Builder.createAndAttachToType(SalesHistory);
/**
 * SOURCE TimePeriodDescription @ squareup/pricingplan/common.proto at 56:3
 */
SalesHistory.TimePeriodDescription = $root.lookupEnum('squareup.pricingplan.service.SalesHistory.TimePeriodDescription').values;
/**
 * SOURCE Rate @ squareup/pricingplan/common.proto at 74:1
 */
export const Rate = $root.lookupType('squareup.pricingplan.service.Rate');
fixType(Rate);
Builder.createAndAttachToType(Rate);
/**
 * SOURCE OfferRateDetails @ squareup/pricingplan/common.proto at 79:1
 */
export const OfferRateDetails = $root.lookupType('squareup.pricingplan.service.OfferRateDetails');
fixType(OfferRateDetails, {
  pricingBundleName: {
    notEmpty: true
  },
  oldRate: {
    required: true
  },
  newRate: {
    required: true
  }
});
Builder.createAndAttachToType(OfferRateDetails);
/**
 * SOURCE PricingBundleSales @ squareup/pricingplan/common.proto at 89:1
 */
export const PricingBundleSales = $root.lookupType('squareup.pricingplan.service.PricingBundleSales');
fixType(PricingBundleSales, {
  pricingBundleName: {
    notEmpty: true
  },
  appliedRate: {
    required: true
  },
  totalSales: {
    required: true
  }
});
Builder.createAndAttachToType(PricingBundleSales);
/**
 * SOURCE TerminationConditions @ squareup/pricingplan/common.proto at 109:1
 */
export const TerminationConditions = $root.lookupType('squareup.pricingplan.service.TerminationConditions');
fixType(TerminationConditions, {
  feeAmount: {
    required: true
  },
  minimumBilledMonths: {
    required: true
  }
});
Builder.createAndAttachToType(TerminationConditions);
/**
 * SOURCE TerminationStatus @ squareup/pricingplan/common.proto at 117:1
 */
export const TerminationStatus = $root.lookupType('squareup.pricingplan.service.TerminationStatus');
fixType(TerminationStatus);
Builder.createAndAttachToType(TerminationStatus);
/**
 * SOURCE FeePlanRate @ squareup/pricingplan/common.proto at 129:1
 */
export const FeePlanRate = $root.lookupType('squareup.pricingplan.service.FeePlanRate');
fixType(FeePlanRate);
Builder.createAndAttachToType(FeePlanRate);
/**
 * SOURCE FetchFlag @ squareup/pricingplan/common.proto at 143:1
 */
export const FetchFlag = $root.lookupEnum('squareup.pricingplan.service.FetchFlag').values;